import {frontend} from 'pageflow-scrolled/frontend';

import {PricingCards} from './PricingCards';

frontend.contentElementTypes.register('pricingCards', {
  component: PricingCards
});
